import { Button, Stack } from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../../../../util/state/GlobalContextProvider";
import { BookingScope } from "../../../../../types";
import { hasScope } from "../../../../../utils";
import { NewNote, NoteList } from "./components";

const TabNotes = () => {

    const { globalData } = useContext(GlobalContext);

    const { t } = useTranslation('booking');

    const [showNewNote, setShowNewNote] = useState<boolean>(false);

    const handleClickAddNote = useCallback(() => {
        setShowNewNote(true);
    }, []);
    const handleCloseNewNote = useCallback(() => {
        setShowNewNote(false);
    }, []);

    return (
        <Stack rowGap={2}>
            <Stack direction="row" justifyContent="end">
                {hasScope(globalData, BookingScope.InsertNote) &&
                    <Button
                        variant="outlined"
                        onClick={handleClickAddNote}
                        disabled={showNewNote}
                    >
                        {t("label.addNote")}
                    </Button>
                }
            </Stack>
            <NewNote show={showNewNote} onClose={handleCloseNewNote} />
            <NoteList isShowingNewNote={showNewNote} />
        </Stack>
    );
}

export default TabNotes;